module.exports = __webpack_public_path__ + "static/media/phone.ce73dd68.png";